export interface RuntimeEnvConfig {
  API_BASE_URL: string;
  REALTIME_BASE_URL: string;
  CDN_URL: string;
  UPLOAD_API_BASE_URL: string;
  ENABLE_BEAUTY: boolean;
}

export function getEnvConfig(): RuntimeEnvConfig {
  return {
    API_BASE_URL: import.meta.env.VITE_API_BASE_URL || "",
    REALTIME_BASE_URL: import.meta.env.VITE_REALTIME_BASE_URL || "",
    CDN_URL: import.meta.env.VITE_CDN_URL || "",
    UPLOAD_API_BASE_URL: import.meta.env.VITE_UPLOAD_API_BASE_URL || "",
    ENABLE_BEAUTY: import.meta.env.VITE_ENABLE_BEAUTY === "true",
  };
}
